if (!customElements.get('r21-measurement-guide')) {
  customElements.define('r21-measurement-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-r21-unit]');
        if (!button || !this.contains(button)) return;
        this.setUnit(button.dataset.r21Unit);
      }, { signal: this.controller.signal });
      this.scrollObserver = new ResizeObserver(() => this.updateScrollHint());
      const scrollArea = this.querySelector('[data-r21-table-scroll]');
      if (scrollArea) this.scrollObserver.observe(scrollArea);
      this.updateScrollHint();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.scrollObserver?.disconnect();
    }

    formatInches(value) {
      return String(Math.round((Number(value) / 2.54 + Number.EPSILON) * 10) / 10);
    }

    convertMeasurement(original) {
      if (/^\d+(?:\.\d+)?$/.test(original)) return this.formatInches(original);
      const range = original.match(/^(\d+(?:\.\d+)?)\s*([–-])\s*(\d+(?:\.\d+)?)$/);
      return range ? `${this.formatInches(range[1])}${range[2]}${this.formatInches(range[3])}` : original;
    }

    convertNote(original) {
      const range = /(\d+(?:\.\d+)?)\s*([–-])\s*(\d+(?:\.\d+)?)\s*(?:cm|centimetres?|centimeters?)\b/gi;
      const single = /(\d+(?:\.\d+)?)\s*(?:cm|centimetres?|centimeters?)\b/gi;
      return original
        .replace(range, (match, minimum, separator, maximum) => `${this.formatInches(minimum)}${separator}${this.formatInches(maximum)} in`)
        .replace(single, (match, value) => `${this.formatInches(value)} in`)
        .replace(/\bcentimetres\b|\bcentimeters\b/gi, 'inches')
        .replace(/\bcentimetre\b|\bcentimeter\b/gi, 'inch')
        .replace(/\bcm\b/gi, 'in');
    }

    setUnit(unit) {
      if (!['cm', 'in'].includes(unit)) return;
      this.dataset.unit = unit;
      this.querySelectorAll('[data-r21-measurement]').forEach((cell) => {
        const original = cell.dataset.r21Measurement;
        cell.textContent = unit === 'cm' ? original : this.convertMeasurement(original);
      });
      this.querySelectorAll('[data-r21-measurement-note]').forEach((note) => {
        const original = note.dataset.r21MeasurementNote;
        note.textContent = unit === 'cm' ? original : this.convertNote(original);
      });
      this.querySelectorAll('[data-r21-unit]').forEach((button) => button.setAttribute('aria-pressed', button.dataset.r21Unit === unit));
      this.querySelectorAll('[data-r21-unit-text]').forEach((label) => { label.textContent = unit.toUpperCase(); });
      const status = this.querySelector('[data-r21-unit-status]');
      if (status) status.textContent = `${this.dataset.unitLabel}: ${unit.toUpperCase()}`;
      this.updateScrollHint();
    }

    updateScrollHint() {
      const scrollArea = this.querySelector('[data-r21-table-scroll]');
      const hint = this.querySelector('[data-r21-scroll-hint]');
      if (!scrollArea || !hint) return;
      hint.hidden = scrollArea.clientWidth === 0 || scrollArea.scrollWidth <= scrollArea.clientWidth + 1;
    }
  });
}
